import { Button, cn, Text } from '@viapeople/components'
import type React from 'react'
import type { IconProps } from '../icons/types'

interface EmptyStateProps {
	icon?: React.ComponentType<IconProps>
	title: string
	description?: string
	actionLabel?: string
	onAction?: () => void
	className?: string
}

export const EmptyState: React.FC<EmptyStateProps> = ({
	icon: Icon,
	title,
	description,
	actionLabel,
	onAction,
	className,
}) => {
	return (
		<div
			className={cn(
				`flex flex-col items-center justify-center py-20 mx-5 my-6 gap-4 bg-neutral-50 text-center rounded-xl ${className}`,
			)}>
			{Icon && <Icon size={32} className='fill-neutral-500' />}
			<div>
				<Text variant='small' weight='semibold'>
					{title}
				</Text>
				{description && (
					<Text variant='small' className='mt-1 text-neutral-500'>
						{description}
					</Text>
				)}
			</div>
			{actionLabel && onAction && (
				<Button variant='primary' onClick={onAction}>
					{actionLabel}
				</Button>
			)}
		</div>
	)
}
